// import { useEffect } from "react";
// import PageHeader from "../components/PageHeader";
// import SectionTitle from "../components/SectionTitle";
// import RoomCard from "../components/RoomCard";
// import BookingForm from "../components/BookingForm";
// import { roomsData } from "../data/roomsData";
// import "../styles/Pages.css";

// const Rooms = () => {
//   useEffect(() => { document.title = "Rooms & Suites | USHA Resort, Patna"; }, []);

//   return (
//     <>
//       <PageHeader
//         title="Rooms & Suites"
//         subtitle="Home · Rooms"
//         image="https://images.unsplash.com/photo-1611892440504-42a792e24d32?auto=format&fit=crop&w=1800&q=80"
//       />

//       <section>
//         <div className="container">
//           <SectionTitle
//             tag="Stay With Us"
//             title="Comfort Meets Elegance"
//             subtitle="Every room at USHA Resort is designed to be your personal retreat — spacious, spotless and stacked with modern comforts."
//           />
//           <div className="rooms-grid gap-top">
//             {roomsData.map((room) => <RoomCard key={room.id} room={room} />)}
//           </div>
//         </div>
//       </section>

//       <section className="booking-section" id="booking">
//         <div className="container">
//           <SectionTitle
//             tag="Reservation"
//             title="Book Your Stay"
//             subtitle="Fill in your details and our team will confirm availability instantly on WhatsApp."
//           />
//           <BookingForm />
//         </div>
//       </section>
//     </>
//   );
// };

// export default Rooms;


import { useEffect } from "react";
import PageHeader from "../components/PageHeader";
import SectionTitle from "../components/SectionTitle";
import RoomCard from "../components/RoomCard";
import BookingForm from "../components/BookingForm";
import { roomsData } from "../data/roomsData";
import "../styles/Pages.css";

const Rooms = () => {
  useEffect(() => { document.title = "Rooms & Suites | USHA Resort, Patna"; }, []);

  return (
    <>
      <PageHeader
        title="Rooms & Suites"
        subtitle="Home · Rooms"
        image="/images/Rooms/Room-4.jpeg"
      />

      <section>
        <div className="container">
          <SectionTitle
            tag="Stay With Us"
            title="Comfort Meets Elegance"
            subtitle="Every room at USHA Resort is designed to be your personal retreat — spacious, spotless and stacked with modern comforts."
          />
          <div className="rooms-grid gap-top">
            {roomsData.map((room) => <RoomCard key={room.id} room={room} />)}
          </div>
        </div>
      </section>

      <section className="booking-section" id="booking">
        <div className="container">
          <SectionTitle
            tag="Reservation"
            title="Book Your Stay"
            subtitle="Fill in your details and our team will confirm availability instantly on WhatsApp."
          />
          <BookingForm />
        </div>
      </section>
    </>
  );
};

export default Rooms;